export default "__VITE_ASSET__ChV12VX3__"